<template>
  <div></div>
</template>
<script>
export default {
  name: 'index'
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/informationDisplay/index.vue